import {
    DEALERBRANCHNAME_SUCCESS,
    DEALERBRANCHNAME_FAILED,
    RESET_DEALERBRANCHNAME,
    LOADING_DEALERBRANCHNAME,
    NETWORK_ERROR_DEALERBRANCHNAME
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERBRANCHNAME:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERBRANCHNAME_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERBRANCHNAME_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERBRANCHNAME:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERBRANCHNAME:
            return (state = initialState);
        default:
            return state;
    }
};
